// SideBar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SideBar.css';
import pinLogo from './assets/pinlogo.png';
import CancellationPopup from './CancellationPopup';

function SideBar({ isOpen, toggleSidebar }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  const handleCancelRedirect = () => {
    toggleSidebar();
    navigate('/terms#financial-terms');
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') toggleSidebar();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [toggleSidebar]);

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'visible' : ''}`} onClick={toggleSidebar}></div>

      <div className={`sidebar-container ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={pinLogo} alt="Logo" className="sidebar-logo" />
          <button className="close-btn" onClick={toggleSidebar} aria-label="Close sidebar">×</button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            <li><Link to="/" onClick={toggleSidebar}><span>Home</span></Link></li>
            <li><Link to="/about" onClick={toggleSidebar}><span>About Us</span></Link></li>
            <li><Link to="/quote" onClick={toggleSidebar}><span>Request a Quote</span></Link></li>
            <li><Link to="/contactus" onClick={toggleSidebar}><span>Contact Us</span></Link></li>
            <li><Link to="/flight-tracker" onClick={toggleSidebar}><span>Secure Upload</span></Link></li>
            <li><Link to="/dashboard" onClick={toggleSidebar}><span>Your Dashboard</span></Link></li>
            <li>
              <a href="https://graystonecalimesa.odoo.com/" target="_blank" rel="noopener noreferrer" onClick={toggleSidebar}>
                <span>Online Store</span>
              </a>
            </li>
            <li>
              <button className="link-button" onClick={() => setIsPopupOpen(true)}>
                <span>Appointment Center</span>
              </button>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <small>
            <Link to="/terms" onClick={toggleSidebar}>
              <span>Terms & Conditions</span>
            </Link>
          </small>
          <small>
            <Link to="/privacy" onClick={toggleSidebar}>
              <span>Privacy Policy</span>
            </Link>
          </small>
          <div className="sidebar-seal">
            <img src="/seal.png" alt="Saint Jude’s Medical Center Seal" className="seal-footer" />
          </div>
        </div>

        {isPopupOpen && (
          <CancellationPopup onClose={() => setIsPopupOpen(false)} onCancel={handleCancelRedirect} />
        )}
      </div>
    </>
  );
}

export default SideBar;